<template>
  <div id="zt592f">
    <div id="k1">
      <div>
        <label>ZT592F</label>
        <label>按键寿命大于100万次</label>
        <span>
          <!-- <img :src="require('@/assets/pic/zt592f/icons.png')" /> -->
        </span>
      </div>
      <!-- <img :src="require('@/assets/pic/zt592f/bgcv1.png')" /> -->
    </div>
    <div id="k2">
      <img :src="require('@/assets/pic/zt592f/icon.png')"/>
    </div>
    <div id="k3">
      <div>防护功能</div>
      <div>产品表面防油、防水、防尘、防暴</div>
    </div>
    <div id="k4">
      <div>产品尺寸</div>
      <div>USB2.0和RS-232接口</div>
    </div>

    <pdspecs :data="spdata"></pdspecs>
  </div>
</template>

<script>
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      // asdata: [
      //   {
      //     label: 'ATM',
      //     pic: require('@/assets/pic/zt592f/as1.jpg')
      //   },
      //   {
      //     label: 'The ticket machine',
      //     pic: require('@/assets/pic/zt592f/as2.jpg')
      //   },
      //   {
      //     label: 'Self-service machine',
      //     pic: require('@/assets/pic/zt592f/as3.jpg')
      //   }
      // ],
      spdata: {
        file: 'zt592f',
        data: [
          {label: '接触电阻', desc: ['小于100欧姆'], pic: 'rsst.png'},
          {label: '扫描方式', desc: ['4×5矩阵式'], pic: 'sctype.png'},
          {label: '按键压力', desc: ['3N~5.5N'], pic: 'bpress.png'},
          {label: '按键寿命', desc: ['大于1,000,000次'], pic: 'btnlife.png'},
          {label: '输入键盘', desc: ['不锈钢按键×20'], pic: 'keyb.png'},
          {label: '按键字符', desc: ['采用高强度油墨制作', '可定制各种文字或符号'], pic: 'scchsize.png'},
          {label: '按键材料', desc: ['SUS304不锈钢'], pic: 'keymt.png'},
          {label: 'EFT', desc: ['能通过重复频率100KHz，', '电压1.0KV抗干扰测试'],pic: 'eft.png'},
          {label: 'ESD', desc: ['可承受接触放电±6KV、', '空气放电±8KV的静电攻击'],pic: 'esd.png'},
          {label: '面板尺寸', desc: ['146mmx120mm'], pic: 'psize.png'},
          {label: '产品尺寸', desc: ['164mm×141mm×27mm'], pic: 'size.png'},
          {label: '产品净重', desc: ['0.59kg'], pic: 'weight.png'},
          {label: '适用环境', desc: ['工作温度： -35℃～+60℃ ','存储温度：-35℃～+70℃','相对湿度：10%～93% RH (不结露)'], pic: 'env.png'},

        ]
      },
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt592f {
  background: black;
  margin-top: -.93rem;
}
#k1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt592f/bg1.jpg');
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding-top: .7rem;
}
#k1 div {
  display: inline-block;
  vertical-align: top;
  margin-top: 2.55rem;
  margin-left: 3.72rem;
  /* width: 4.138rem; */
  color: white;
}
#k1 label {
  display: block;
  font-size: .6rem;
  font-weight: bold;
  /* color: #333333; */
}
#k1 label:nth-child(2) {
  font-size: .36rem !important;
  font-weight: 500 !important;
  /* color: #313333 !important; */
  margin-top: .05rem;
  width: 4.31rem;
}


#k2 {
  background: #EEEEEE ;
  text-align: center;
  height: 1.78rem;
  overflow: hidden;
  box-sizing: border-box;
  /* line-height: 1.78rem !important; */
}

#k2 img {
  margin: .55rem auto;
  /* height: .8rem; */
}

#k3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt592f/bg2.jpg');
  background-size: 100% 100%;
  color: white;
  overflow: hidden;
  padding-left: 3.46rem;
}
#k3 div:nth-child(1) {
  margin-top: 2.77rem;
  font-size: .58rem;
  font-weight: bold;
  color: #4C4D4C;
}
#k3 div:nth-child(2) {
  font-size: .36rem;
  font-weight: 500;
  color: #666666;
  width: 6.1rem;
  margin-top: .1rem;
}

#k3 img {
  width: 2.7rem;
  height: 3.89;
  margin-left: 8.4rem;
}

#k4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt592f/bg3.jpg');
  background-size: 100% 100%;
  color: white;
  overflow: hidden;
  text-align: center;
}
#k4 div:nth-child(1) {
  font-size: .6rem;
  font-weight: bold;
  color: #4D4D4D;
  width: 6rem;
  margin: .55rem auto 0 auto;
}
#k4 div:nth-child(2) {
  font-size: .36rem;
  font-weight: 500;
  color: #666666;
  width: 6.2rem;
  margin: .1rem auto 0 auto;
}




</style>
